import { Link, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import useLadyService from '@/services/LadyService';
import { selectActiveTabId, setActiveTabId } from '@/stores/slices/tabSlice';
import { useSelector } from 'react-redux';
import { TopLinksTabsObj } from './index';
import { getProfileStatus } from '@/stores/slices/userProfileSlice';
import { useMemo } from 'react';

const HeaderTabs = ({ lk }) => {
	const { userType, dispatch } = useLadyService();

	const activeTabId = useSelector(selectActiveTabId);
	const { pathname } = useLocation();
	const profileStatus = useSelector(getProfileStatus);

	const allTabs = TopLinksTabsObj();

	const tabsData = useMemo(() => {
		const userTypeLinks = () => {
			switch (userType) {
				case 'photograph': {
					return allTabs.photograph;
				}

				case 'indi': {
					return lk ? allTabs.indi_lk : allTabs.indi;
				}

				case 'admin':
				case 'moderator': {
					return allTabs.admin_lk;
				}

				case 'agency': {
					return  allTabs.agency;
				}

				default:
					return allTabs.customer;
			}
		};

		return userTypeLinks() ?? [];
	}, [userType, lk, profileStatus, allTabs]);

	useEffect(() => {
		const activeTab = tabsData.find((tab) => {
			const newUrl = tab.href.replace(/.*\/(lk)/, '$1');
			const newPathname = pathname.replace(/.*\/(lk)/, '$1');

			return newUrl === newPathname;
		});

		dispatch(setActiveTabId(activeTab?.id));
	}, [pathname, userType, tabsData]);

	return tabsData.map((i) => {
		return (
			<Link
				data-counter={i.count}
				key={i.id}
				className={`header__tab ${i.count < 1 ? ' empty' : ''} ${
					activeTabId === i.id ? '_active' : ''
				} ${i.disabled ? 'tab-disabled' : ''}`}
				to={`${i.href}`}
				onClick={(e) => {
					if (i.disabled && i.onClick) {
						e.preventDefault();
						i.onClick();
					} else {
						dispatch(setActiveTabId(i.id));
					}
				}}
			>
				{i.name}
				{i.wallet || i.wallet === 0 ? (
					<span className={`color-green currency--erocoin`}>
						{i.wallet}
					</span>
				) : null}
			</Link>
		);
	});
};

export default HeaderTabs;
